import { styled } from '@mui/material'
import MuiTable from '@mui/material/Table'
import { TableProps } from './Table.types'

export const Table = styled(MuiTable)<TableProps>``
